export default __webpack_public_path__ + "static/media/img7.cb658f95.jpg";